<div class="modal-header">
    <h4 class="modal-title">Autorisationer / ID som udløber indenfor 30 dage</h4>
    <button (click)="onDismiss()" type="button" data-bs-theme="dark" class="btn-close" aria-label="Close" tabindex="-1"></button>
</div>

<div class="modal-body">
    <table class="table table-hover table-striped table-sm">
        <thead>
            <th scope="col">Kundenr</th>
            <th scope="col">Navn</th>
            <th scope="col">Autorisation / ID</th>
            <th scope="col">Udløb</th>
        </thead>
        <tbody>
            <tr *ngFor="let autorisation of autorisationer"
            class="clickable"
            (click)="onOpenClient(autorisation)">
                <td>{{autorisation?.glkundenr}}</td>
                <td>{{autorisation.navn1}}</td>
                <td>{{autorisation.autorisation}}</td>
                <td>{{autorisation.udlob | date:'dd-MM-yyyy'}}</td>
            </tr>
        </tbody>
    </table>
</div>
